var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('BarChart',{ref:"barChartRef",attrs:{"chartData":_vm.datasets,"options":_vm.options}})
}
var staticRenderFns = []

export { render, staticRenderFns }